
import { ModalConfig } from '@/store/modules/ui/ui.interfaces';
import { defineComponent, PropType } from 'vue';
import Button from '@/components/form/Button.vue';
import Icon from '@/components/content/Icon.vue';

export default defineComponent({
  name: 'QaModal',
  components: { Button, Icon },
  props: {
    data: {
      type: Object as PropType<ModalConfig>,
      default: Object,
    },
  },
  setup(props, ctx) {
    function primary() {
      ctx.emit('close', props.data?.id);
      ctx.emit('primary');
    }
    function secondary() {
      ctx.emit('close', props.data?.id);
      ctx.emit('secondary');
    }

    return {
      primary,
      secondary,
    };
  },
});
